<!-- 云导播模板预览 -->
<template>
    <div class="material-template-preview">
        <div v-for="(item, idx) in items" :key="idx">
            <!-- 滚动范围 -->
            <div v-if="item.displayType == 1" :style="rollAreaStyle(item)"></div>
            <!-- 文字 -->
            <div v-if="item.fontSize" :style="imageStyle(item)"></div>
            <!-- 图片 -->
            <pretty-image v-else :src="uploadServerUrl+(item.originPath || item.path)" :style="imageStyle(item)" />
        </div>
    </div>
</template>
<script>
import PrettyImage from './PrettyImage.vue';
var SCENE = {
    width: 1280,
    height: 720
};
export default {
    components: { PrettyImage },
    name: "MaterialTemplatePreview",
    props: {
        data: {
            required: true
        },
        uploadServerUrl: {
            type: String
            // required: true
        }
    },
    data() {
        let items = [];
        try {
            items = JSON.parse(this.data);
        } catch (error) {
            console.log(error);
        }
        return { items };
    },
    methods: {
        normalData(data) {
            let content = data.content || "";
            if (data.type == 1) {
                content = "1111-11-11 11:11:11";
            }
            let height = data.height || data.fontSize;
            let width =
                data.width || (data.content && data.content.length * height);
            return {
                content,
                height,
                width
            };
        },
        imageStyle(data) {
            let normal = this.normalData(data);
            let x = data.originX || data.xcoordinate;
            let y = data.originY || data.ycoordinate;
            let w = data.originW || data.width;
            let h = data.originH || data.height;
            if(data.displayType == 1) {
                x += data.rollX;
                y += data.rollY;
            }
            return {
                position: "absolute",
                left: (x / SCENE.width) * 100 + "%",
                top: (y / SCENE.height) * 100 + "%",
                width: (w / SCENE.width) * 100 + "%",
                height: (h / SCENE.height) * 100 + "%",
                "background-color": "#" + data.fontColor
            };
        },
        rollAreaStyle(data) {
            return {
                position: "absolute",
                left: (data.rollX / SCENE.width) * 100 + "%",
                top: (data.rollY / SCENE.height) * 100 + "%",
                width: (data.rollW / SCENE.width) * 100 + "%",
                height: (data.rollH / SCENE.height) * 100 + "%",
                border: "1px dashed #fff",
                background: "none",
                overflow: "hidden"
            };
        }
    }
};
</script>
<style lang="less" scoped>
.material-template-preview {
    border: 2px solid #aaa;
    background: #aaa;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
}
</style>